import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  DIALOG_BUTTON_TYPE,
  DialogMessageContents,
  ModalDialog,
} from '@/components/Elements';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';

import { useSilenceContinuousError } from '../../hooks/error/useSilenceContinuousError';

type ContinuousErrorDialog = {
  // ダイアログ表示/非表示
  isOpen: boolean;
  // STTスタート
  startSTT: () => void;
};

/**
 * 連続使用エラーダイアログ コンポーネント
 *
 * @param param0 本ダイアログ表示/非表示
 * @returns
 */
export const ContinuousErrorDialog = React.memo(
  ({ isOpen, startSTT }: ContinuousErrorDialog) => {
    const { clickCancelButtonContinuous, clickRestartButton } =
      useSilenceContinuousError();
    const { sttContinueTime } = useLoginUserInfo();
    const { t } = useTranslation();

    return (
      <ModalDialog
        isOpen={isOpen}
        title={t('translationDialog.利用を再開しますか？').toString()}
        buttons={[
          {
            label: t('translationDialog.キャンセル'),
            onClick: clickCancelButtonContinuous,
            type: DIALOG_BUTTON_TYPE.CHANCEL,
            gtmClassTag: 'dts-error-90minutes-cancel',
          },
          {
            label: t('translationDialog.再開'),
            onClick: () => {
              clickRestartButton(startSTT);
            },
            gtmClassTag: 'dts-error-90minutes-restart',
          },
        ]}
      >
        <DialogMessageContents>
          {t(
            'translationDialog.{num}分連続で使用されたため自動的に停止しました。',
            {
              num: sttContinueTime,
            },
          )}
          {sttContinueTime <= 0 && <p>{t('translationDialog.logionAgain')}</p>}
        </DialogMessageContents>
      </ModalDialog>
    );
  },
);
